export default __webpack_public_path__ + "9fe9c0b1fa2691f66ddd57a38f111d8c.svg";